module.exports = "/images/example_case_2.png?5146f7dd4c8cc0787994b83f3aa1dadf";